import { ListingStatus } from '@apeiron/common'
import EmporiumSecNavBar from '@src/components/navigationBar/secondary/EmporiumSecNavBar'
import PlanetThirdNavBar from '@src/components/navigationBar/third/PlanetThirdNavBar'
import PlanetListWithFilter from '@src/components/planet/list/PlanetListWithFilter'
import { GAAssetType } from '@src/constants/googleAnalytics'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import withListTracking from '@src/hoc/withListTracking'
import useQueryInject from '@src/hooks/common/router/useQueryInject'
import { NextPage } from 'next'
import { useEffect } from 'react'

const DEFAULT_QUERY = { nftListingStatus: ListingStatus.LISTING }

const WithTrackingPlanetList = withListTracking(GAAssetType.Planet)(
  PlanetListWithFilter
)

const PlanetItemPage: NextPage<Props> = () => {
  const { setupBar } = useSecondaryNavBarContext()

  const { injected: allowFetch } = useQueryInject(DEFAULT_QUERY)

  useEffect(() => {
    setupBar(<EmporiumSecNavBar index={0} />)

    return () => setupBar(null)
  }, [setupBar])

  return (
    <WithTrackingPlanetList
      allowFetch={allowFetch}
      thirdNavBar={<PlanetThirdNavBar index={0} />}
    />
  )
}

type Props = {}

export default PlanetItemPage
